import { createFileRoute } from '@tanstack/react-router';

import { MembershipPlansPage } from '../modules/memberships/ui/pages/MembershipPlansPage';

export const Route = createFileRoute('/_authenticated/dashboard/memberships/plans/')({
  component: MembershipPlansPage,
  staticData: {
    breadcrumb: ['Memberships', 'Plans'],
  },
});
